<div class="row">
    <div class="col-sm-9">
      <div class="booking_ht">
      <!-- <sm-title-bar pageTitle="All inventory status"></sm-title-bar> -->
      <sm-title-bar pageTitle="All inventory status" [backWithParams]="true"></sm-title-bar>

  </div>
  </div>
  <div class="col-sm-3">
    <!-- <div class="search_bar_custom">
      <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search for services">
          <button mat-icon-button matSuffix>
              <mat-icon>search</mat-icon>
          </button>
      </mat-form-field>
  </div> -->
  </div>
  </div>
  <mat-card *ngIf="!loader && inventoryStatusData.length > 0">
      <div class="rounded-3 bg-light">
        <sm-data-table [columnHeaders]="tableDisplayColumns" 
                       [showImageColumn]="true" 
                       [imageTemplate]="image" 
                       [dataSource]="inventoryStatusData" 
                      
                       [showPagination]="true" 
                       [itemsPerPage]="25">
        </sm-data-table>
      </div>
    </mat-card>
    <ng-template #menuTemplate let-rowvalue>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">edit</mat-icon>
        <span>Edit</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span>Delete</span>
      </button>
    </ng-template>
    <ng-template #image let-objValue>
      <img
        [src]="
          objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
            ? objValue['image_thumb_url']
          : './assets/images/salon_support_header.png'
        "
        class="img-fluid rounded-circle"
      />
      <span style="height: 15px; width: 15px; background-color: red; border-radius: 50%; display: block; position: relative;bottom: 12px;
    left: 28px;" [ngStyle]="{'background-color': objValue['current_purchase_stock'] <= 0 || objValue['current_purchase_stock'] == null
    ? 'red'
    : objValue['current_purchase_stock'] > 0 && objValue['current_purchase_stock'] <= objValue['min_stock']
        ? 'yellow'
        : 'green'}">
  
    </span>
    </ng-template>